const modules = {}
const files = require.context('.', true, /^(?!.*(?:ignore)).*\.vue$/)

files.keys().forEach(fileName => {
  const name = fileName.replace('./', '').replace('.vue', '')
  const file = files(fileName)

  modules[file.alias || name] = file
})

export default modules



// WEBPACK FOOTER //
// ./src/components/_modules/Dashboard/widgets/index.js